import {CommonModule} from '@angular/common';
import {Component, inject, OnInit, Input} from '@angular/core';
import {
    AccessType,
    AuthService,
    ChecklistClient, ChecklistCompliance,
    ChecklistComplianceScoreExportQuery,
    ChecklistComplianceScoreQuery, IMyScoreShiftQuery, ITrendingQuery,
    PermissionType,
} from "@services";
import {ChecklistComplianceTrendingQuery} from "@services";
import {ScoreDashboardComponent} from "../../../components/library/score-dashboard/score-dashboard.component";

export function checklistCompliancePalette(): Record<string, string> {
    const getColor = (name: string) => getComputedStyle(document.body).getPropertyValue(name).trim();
    return {
        [ChecklistCompliance.Created]: getColor('--bs-success'),
        [ChecklistCompliance.Missing]: getColor('--bs-danger'),
    };
}

@Component({
    selector: 'app-checklist-compliance-score',
    imports: [CommonModule, ScoreDashboardComponent],
    templateUrl: './checklist-compliance.component.html'
})
export class ChecklistComplianceComponent implements OnInit {
    private checklistClient = inject(ChecklistClient)
    protected authService = inject(AuthService);

    @Input() employeeId: string | null;
    @Input() daysLookBack: number = 0;

    palette: Record<string, string> = {};

    loadScoreData = (query: IMyScoreShiftQuery) => {
        return this.checklistClient.getChecklistComplianceScore(new ChecklistComplianceScoreQuery(query));
    }

    loadTrendingData = (query: ITrendingQuery) => {
        return this.checklistClient.getChecklistComplianceTrending(new ChecklistComplianceTrendingQuery(query));
    }

    exportData = (from: Date, to: Date, userId: string | null) => {
        const query = new ChecklistComplianceScoreExportQuery({ from, to, userId });
        return this.checklistClient.exportChecklistComplianceScore(query);
    }

    ngOnInit(): void {
        this.palette = checklistCompliancePalette();

        if (!this.authService.checkPermission(PermissionType.ChecklistCompliance, AccessType.Manage)) {
            this.employeeId = this.authService.userId;
        }
    }
}
